import Vue from 'vue'
import Store from 'store'

import ShopFilterContainer from './ShopFilterContainer.vue'

const el = '.nti-component--shop-filter'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                ShopFilterContainer
            },
            template: '<ShopFilterContainer />'
        })
    }
}

export default {
    render
}